<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ title }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12="xs12" sm4="sm4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
            clearable="clearable"
          >
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="invoice"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left" @click="viewInvoice(props.item)">
              <a @click="viewInvoice(props.item)">{{ props.item.invoiceID }}</a>
            </td>
            <td class="text-xs-left">
              {{ $moment(props.item.createDateTime).format("MM/DD/YYYY") }}
            </td>
            <td class="text-xs-left">
              <div v-if="props.item.Store">
                <a @click="open(props.item)">{{ props.item.Store.CSPID }}</a>
                <v-icon small="small" v-if="props.item.Store.isLocked">lock</v-icon>
              </div>
            </td>
            <td class="text-xs-left" v-if="props.item.Store">
              {{ props.item.Store.businessName }}
            </td>

            <td class="text-xs-right">{{ props.item.invoiceAmount | currency }}</td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left" offset-y="offset-y">
                <v-btn slot="activator" icon="icon">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="menu-button">
                  <v-list-tile @click="open(props.item)">
                    <v-list-tile-title>{{ $t("buttons.openStorePage") }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="!props.item.paidDateTime"
                    :to="`/invoice/edit/${props.item.invoiceID}`"
                  >
                    <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="checkRightStatus(51) && props.item.paidDateTime"
                    :to="`/invoice/edit/${props.item.invoiceID}`"
                  >
                    <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider> </v-divider>
                  <v-list-tile @click="viewInvoice(props.item)">
                    <v-list-tile-title>{{ $t("buttons.view") }} </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import invoiceService from "../service.js";
import { mapGetters } from "vuex";
export default {
  name: "missing-invoice-list",
  data() {
    return {
      invoice: [],
      loading: true,
      paymentDialog: false,
      selectedInvoice: null,
      title: "Missing Serial Number List",
      headers: [
        {
          text: this.$t("labels.invoiceNumber"),
          value: "invoiceID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.createdAt"),
          value: "createDateTime",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.businessName"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.invoiceAmount"),
          value: "invoiceAmount",
          width: "10%",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "chargeDateTime",
        descending: false
      }
    };
  },
  activated() {
    this.getMissingSerailList();
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"])
  },
  created() {
    this.getMissingSerailList();
  },
  methods: {
    open(data) {
      console.log("dsfasdf", data);
      this.$router.push({ path: `/location/profile/${data.Store.storeID}` });
    },
    viewInvoice(data) {
      let routeData = this.$router.resolve({ path: `/global/invoice/${data.invoiceID}/view` });
      window.open(routeData.href, "newwindow", "width=800, height=950");
    },
    getMissingSerailList() {
      this.loading = true;
      console.log("this.$route.params.id", this.$route.params.id);
      return invoiceService.missingSerialNumber(this.$route.params.id).then(response => {
        console.log("missing data", response);
        this.invoice = response.data;
        this.loading = false;
        return response;
      });
    }
  }
};
</script>

<style scoped></style>
